import api from '../api'

export default {
    namespaced: true,
    state: {
        batchUserStatsInner: {// 战绩批量查询内页
            beanList: [],
            total: 0
        },
    },
    mutations: {
        setStateBatchUserStatsInner(state, info) {
            state.batchUserStatsInner = info
        }
    },
    actions: {
        getPlatformUserStats(store, params) {
            return api.post('/gameDetail/platform/user/stats', '平台玩家牌局信息 - 列表', params)
        },
        getPlatformRoomStats(store, params) {
            return api.post('/gameDetail/platform/room/stats', '平台牌局信息 - 列表', params)
        },
        getTribeUserStats(store, params) {
            return api.post('/gameDetail/tribe/user/stats', '联盟牌局信息-列表', params)
        },
        getClubRoomStats(store, params) {
            return api.post('/gameDetail/club/room/stats', '俱乐部牌局信息-列表', params)
        },
        getUserStats(store, params) {
            return api.post('/gameDetail/user/stats', '用户牌局信息-列表', params)
        },
        getBatchUserStats(store, params) {
            return api.post('/gameDetail/batch/user/stats', '战绩批量查询-列表', params)
        },
        getBatchUserStatsInner({commit}, params) {
            return api.post('/gameDetail/batch/user/stats/inner', '战绩批量查询-内页', params).then(res => {
                commit('setStateBatchUserStatsInner', res.data)
            })
        }
    }
}